var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcoGenderMale = function SvgIcoGenderMale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9032 1.66667H12.9317C12.1762 1.66667 11.7977 2.57844 12.3321 3.11174L13.3764 4.15436L11.3783 6.14896C10.3191 5.42025 9.08427 5.05555 7.85118 5.05555C6.15851 5.05548 4.46654 5.74122 3.2271 7.11505C1.08048 9.49622 1.15843 13.2875 3.39457 15.5837C4.64854 16.8722 6.26891 17.5 7.88787 17.5C9.47931 17.5 11.0743 16.894 12.2897 15.6818C14.4452 13.5306 14.6801 10.1935 13.01 7.77744L15.0081 5.78284L16.0525 6.82547C16.226 6.99618 16.4377 7.07378 16.6458 7.07378C17.0796 7.07378 17.4993 6.73517 17.4993 6.22726V2.23101C17.4993 1.95096 17.2454 1.66667 16.9032 1.66667ZM10.2863 13.6872C9.62498 14.3471 8.75625 14.6772 7.88787 14.6772C7.01913 14.6772 6.15075 14.3473 5.48906 13.6872C4.16638 12.367 4.16638 10.2189 5.48906 8.89731C6.1504 8.23738 7.01913 7.90724 7.88787 7.90724C8.7566 7.90724 9.62498 8.23728 10.2863 8.89731C11.609 10.2165 11.609 12.368 10.2863 13.6872Z",
    fill: "#028BB7"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoGenderMale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-gender-male.dc703ec3.svg";
export { ForwardRef as ReactComponent };